import {
  UPLOAD_SP_SET_MALL,
  UPLOAD_SP_SET_STORE,
} from '../../actions/types';

const initalizeState = {
  mall: {
    id:   localStorage.getItem('upload_ms_mall_id'),
    name: localStorage.getItem('upload_ms_mall_name'),
  },
  store: {
    id:         localStorage.getItem('upload_ms_store_id'),
    name:       localStorage.getItem('upload_ms_store_name'),
    outletId:   localStorage.getItem('upload_ms_store_outletId'),
    postalCode: localStorage.getItem('upload_ms_store_postalCode'),
  },
};

export default function (state = initalizeState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPLOAD_SP_SET_MALL:
      localStorage.setItem('upload_ms_mall_id', payload.id);
      localStorage.setItem('upload_ms_mall_name', payload.name);
      return {
        ...state,
        mall: {
          id:   payload.id,
          name: payload.name,
        },
      };
    case UPLOAD_SP_SET_STORE:

      localStorage.setItem('upload_ms_store_id', payload.id);
      localStorage.setItem('upload_ms_store_name', payload.name);
      localStorage.setItem('upload_ms_store_outletId', payload.outletId);
      localStorage.setItem('upload_ms_store_postalCode', payload.postalCode);
      return {
        ...state,
        store: {
          id:         payload.id,
          name:       payload.name,
          outletId:   payload.outletId,
          postalCode: payload.postalCode,
        },
      };
    default:
      return state;
  }
}
